import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { getSlugByLang } from '../common/Helper';

export default function LanguageSyncRedirect() {
    const navigate = useNavigate();
    const location = useLocation();
    const prevLangRef = useRef();
    const user = useSelector((state) => state.user);

    const currentLang = getSlugByLang(user?.language) || 'en';

    useEffect(() => {
        const pathParts = location.pathname.split('/');
        const currentPathLang = pathParts[1];

        // Only redirect if lang changed
        if (currentPathLang !== currentLang) {
            // Replace old lang with new one
            pathParts[1] = currentLang;
            const newPath = pathParts.join('/');
            navigate(newPath, { replace: true });
        }

        prevLangRef.current = currentLang;
    }, [user?.language, location.pathname, navigate, currentLang]);

    return null;
};
